var _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8849,
    cy: 33.3106,
    rx: 33.8849,
    ry: 33.3106,
    fill: "#D6CCFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.6139,
    cy: 33.1121,
    rx: 29.6002,
    ry: 29.0985,
    fill: "#6F52ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.665 21.9911L27.4875 25.1686H21.4059V44.2331H46.8253V25.1686H40.7437L37.5663 21.9911H30.665ZM29.3495 18.8137H38.8818L42.0592 21.9911H48.414C48.8354 21.9911 49.2395 22.1585 49.5374 22.4565C49.8354 22.7544 50.0028 23.1585 50.0028 23.5799V45.8218C50.0028 46.2432 49.8354 46.6473 49.5374 46.9452C49.2395 47.2432 48.8354 47.4105 48.414 47.4105H19.8172C19.3959 47.4105 18.9918 47.2432 18.6938 46.9452C18.3959 46.6473 18.2285 46.2432 18.2285 45.8218V23.5799C18.2285 23.1585 18.3959 22.7544 18.6938 22.4565C18.9918 22.1585 19.3959 21.9911 19.8172 21.9911H26.1721L29.3495 18.8137ZM34.1156 42.6444C31.7982 42.6444 29.5757 41.7238 27.937 40.0851C26.2983 38.4465 25.3777 36.2239 25.3777 33.9065C25.3777 31.589 26.2983 29.3665 27.937 27.7278C29.5757 26.0892 31.7982 25.1686 34.1156 25.1686C36.4331 25.1686 38.6556 26.0892 40.2943 27.7278C41.933 29.3665 42.8536 31.589 42.8536 33.9065C42.8536 36.2239 41.933 38.4465 40.2943 40.0851C38.6556 41.7238 36.4331 42.6444 34.1156 42.6444ZM34.1156 39.467C35.5904 39.467 37.0047 38.8811 38.0475 37.8383C39.0903 36.7956 39.6761 35.3812 39.6761 33.9065C39.6761 32.4318 39.0903 31.0174 38.0475 29.9746C37.0047 28.9318 35.5904 28.346 34.1156 28.346C32.6409 28.346 31.2266 28.9318 30.1838 29.9746C29.141 31.0174 28.5551 32.4318 28.5551 33.9065C28.5551 35.3812 29.141 36.7956 30.1838 37.8383C31.2266 38.8811 32.6409 39.467 34.1156 39.467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraMenu);
export default __webpack_public_path__ + "static/media/camera-menu.f4bdb7eca80e2c12fab07a741e0c4c74.svg";
export { ForwardRef as ReactComponent };